<script module>
	import Icon from '@isoftdata/svelte-icon'
</script>

<Icon
	class="text-warning"
	icon="pencil"
	size="xs"
/>
